import script from "./success.vue?vue&type=script&lang=js&setup=true"
export * from "./success.vue?vue&type=script&lang=js&setup=true"

import "./success.vue?vue&type=style&index=0&id=0ba04493&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ba04493"]])

export default __exports__